import React from 'react';
import './FormActions.scss';

const FormActions = ({children}) => {
  return <div className='form__actions'>{children}</div>;
};

export default FormActions;
